/** Global support PDFs (Firebase Console upload under global/). */

export const QUICK_START_GUIDE_STORAGE_PATH = 'global/Crewchainquickstart.pdf';
